
export const ICONS = {
	ADD: 'add',
	ADD_EVENT: 'addEvent',
	ADD_CLOSE_CIRCLE: 'addCloseCircle',
	ANIMATION: 'animation',
	ARROW_UP_FULL: 'arrowUpFull',
	ARROW_UP: 'arrowUp',
	ARROW_DOWN: 'arrowDown',
	ARROW_LEFT: 'arrowLeft',
	ARROW_LEFT_CURVED: 'arrowLeftCurved',
	ARROW_RIGHT: 'arrowRight',
	ATTACHMENT: 'attachment',
	KEYBOARD_ARROW_UP: 'keyboardArrowUp',
	KEYBOARD_ARROW_DOWN: 'keyboardArrowDown',
	CALENDAR: 'calendar',
	CAMERA_ON: 'camera',
	CAMERA_OFF: 'cameraOff',
	CHECK: 'check',
	CHECK_V2: 'checkV2',
	COPY: 'copy',
	COPY_FILLED: 'copyFilled',
	CLOSE: 'close',
	CLOSE_WIDE: 'closeWide',
	DISSOLVE: 'dissolve',
	DOWNLOAD_SPEED: 'downloadSpeed',
	EDIT: 'edit',
	EMOJI: 'emoji',
	ERROR: 'error',
	FIT: 'fit',
	FOLDER: 'folder',
	FULLSCREEN: 'fullscreen',
	INFO_CIRCLE: 'infoCircle',
	INFO_OUTLINE: 'infoOutline',
	INTERNET_SPEED: 'internetSpeed',
	KEYBOARD_ARROW_LEFT: 'keyboardArrowLeft',
	KEYBOARD_ARROW_RIGHT: 'keyboardArrowRight',
	MESSAGE: 'message',
	MICROPHONE_ON: 'microphoneOn',
	MICROPHONE_OFF: 'microphoneOff',
	LIST: 'list',
	LINK: 'link',
	LINK2: 'link2',
	LIVE: 'live',
	LOG_OUT: 'logOut',
	PEOPLE: 'people',
	PHOTO: 'photo',
	REFRESH: 'refresh',
	REFRESH_CIRCLE: 'refreshCircle',
	SEARCH: 'search',
	SEND: 'send',
	SETTINGS: 'settings',
	SHARE_SCREEN: 'shareScreen',
	SOUND: 'sound',
	TAKES: 'takes',
	THREE_DOTS_HORIZONTAL: 'threeDotsHorizontal',
	THREE_DOTS_VERTICAL: 'threeDotsVertical',
	THREE_LINES_TRIANGLE: 'threeLinesTriangle',
	UNLINK: 'unlink',
	VIEWERS_EYE: 'viewersEye',
	VIRTUAL_BACKGROUND: 'virtualBackground',
	BACKGROUND_REMOVE: 'background-remove',
	BACKGROUND_RESTORE: 'background-restore',
	BOLD: 'bold',
	ITALIC: 'italic',
	UNDERLINE: 'underline',
	UNDO: 'undo',
	REDO: 'redo',
	OL: 'ol',
	UL: 'ul',
	ALIGN_RIGHT: 'align-right',
	ALIGN_CENTER: 'align-center',
	ALIGN_LEFT: 'align-left',
	TRASH: 'trash',
	FONT: 'font',
	SHARE: 'share',
	QUESTION: 'question',
	TITLES_ON: 'titlesOn',
	TITLES_OFF: 'titlesOff',
	INVITE: 'invite',
	ADD_INVITE: 'addInvite',
	TAB_CHAT: 'tabChat',
	TAB_FEEDS: 'tabFeeds',
	TAB_MEDIA: 'tabMedia',
	TAB_NOTES: 'tabNotes',
	CHECK_CIRCLE: 'checkCircle',
	REFRESH_TRANSPARENT: 'refreshTransparent',
	SETTINGS_SLIDERS: 'settingsSliders',
	COMPUTER: 'computer',
	PHONE: 'phone',
	EMAIL: 'email',
	RADIO_ON: 'radioOn',
	PLAY: 'play',
	PAUSE: 'pause',
	CLOCK: 'clock',
	STOP_LIVE: 'stop-live',
	HEADPHONES: 'headphones',
	CHAT_NOTIFICATION: 'chatNotification',
	EVENT_NOTIFICATION: 'eventNotification',
	REHEARSAL_NOTIFICATION: 'rehearsalNotification',
	TECH_CHECK_NOTIFICATION: 'techcheckNotification',
	TELLY_NOTIFICATION: 'tellyNotification',
	BELL: 'bell',
	SEND_INVITE: 'sendInvite',
	MAXIMIZE: 'maximize',
	UPLOAD: 'upload',
	PRESENTERS: 'presenters',
	PRESENTERS_UNFILLED: 'presentersUnfilled',
	DESIGN: 'design',
	TEMPLATE_ADD: 'templateAdd',
	TEMPLATES: 'templates',
	MOVE: 'move',
	ZOOM_IN: 'zoomIn',
	ZOOM_OUT: 'zoomOut',
	PERSON_IN_SHOT: 'personInShot',
	CONNECTION: 'connection',
	EXPAND: 'expand',
	NOTE: 'note',
	TELEPROMPTER: 'teleprompter',
	FORWARD: 'forward',
	BACKWARD: 'backward',
	MEDIA_CONVERT: 'mediaConvert',
	MEDIA_DELETE: 'mediaDelete',
	MEDIA_DOWNLOAD: 'mediaDownload',
	MEDIA_DUPLICATE: 'mediaDuplicate',
	MEDIA_EDIT: 'mediaEdit',
	MEDIA_SHARE: 'mediaShare',
	MEDIA_TRIM: 'mediaTrim',
	SHOWBOARD_ELLIPSES: 'showboardEllipses',
	PREVIEW: 'preview',
	AUDIO_MUTED: 'audioMuted',
	STREAM: 'stream',
	RECORD: 'record',
	FAST_FORWARD: 'fastForward',
	SKIP_ARROWS: 'skipArrows',
	PLAY_PADDING: 'playPadding',
	VOLUME_0: 'volume0',
	VOLUME_1: 'volume1',
	VOLUME_2: 'volume2',
	VOLUME_3: 'volume3',
	VOLUME_MUTE: 'volumeMute',
	SQUARE: 'square',
	MUSIC: 'music',
	MUSIC_NOTE: 'musicNote',
	MUSIC_NOTE_NEW: 'musicNoteNew',
	LOOP_TRACK_ON: 'loopTrackOn',
	LOOP_TRACK_OFF: 'loopTrackOff',
	RECORDING: 'recording',
	VIDEO: 'video',
	SCREENSHARE: 'screenshare',
	STOP_SCREENSHARE: 'stopScreenshare',
	SHOT_AUTOPLAY_MANUAL: 'shotAutoplayManual',
	SHOT_AUTOPLAY_AUTO: 'shotAutoplayAuto',
	TITLES: 'titles',
	FILTER: 'filter',
	CARROT_DOWN: 'CarrotDown',
	CARROT_UP: 'CarrotUp',
	DOWNLOAD_ICON: 'DownloadIcon',
	MUTE_SOUND: 'muteSound',
	PLAY_RESET: 'playReset',
	CHECK_PROCESSING: 'checkProcessing',
	STREAM_PLAY: 'streamPlay',
	STREAM_RECORD: 'streamRecord',
	STREAM_STOP: 'streamStop',
	STREAM_SCHEDULE: 'streamSchedule',
	EYE_HIDDEN: 'eyeHidden',
	EYE_SHOWN: 'eyeShown',
	CLOCK_ALT: 'clockAlt',
	TIMER: 'timer',
	LOCK: 'lock',
	DRAG: 'drag',
	IMAGE: 'image',
	SPARKLE: 'sparkle',
	SPARKLE_AI: 'sparkle_ai',
	BRIEFCASE: 'briefcase',
	SEND_FILLED: 'sendFilled',
	EMAIL_FILLED: 'emailFilled',
	ADD_MEDIA: 'addMedia',
	MEDIA_FILE: 'mediaFile',
	PERSON_BLUR: 'personBlur',
	PERSON: 'person',
	PERSON_UNFILLED: 'person-unfilled',
	MEDIA: 'media',
	MEDIA_UNFILLED: 'mediaUnfilled',
	CHECK_FILLED: 'checkFilled',
	CHECK_UNFILLED: 'checkUnfilled',
	QUALITY: 'quality',
	WALKUPS: 'walkups',
	SEGMENT: 'segment',
	COUNTDOWN: 'countdown',
	TRANSITION: 'transition',
	LOWER_THIRDS: 'lowerThirds',
	LOCATION: 'location',
	MONITOR: 'monitor',
	ACCORDION_UP: 'accordionUp',
	ACCORDION_DOWN: 'accordionDown',
	LEAVE: 'leave',
	PRIVATE: 'private',
	EYEDROPPER: 'eyedropper',
	TEXT_UNDERLINE: 'textUnderline',
	MONITOR_CANVAS: 'monitorCanvas',
	MONITOR_PRESENTER: 'monitorPresenter',
	INFO: 'info',
	FILM_CAMERA: 'filmCamera',
	QUESTION_CIRCLE: 'questionCircle',
	ANIMATION_OUT: 'animationOut',
	ANIMATION_IN: 'animationIn',
	ANIMATION_TIMER: 'animationTimer',
	ANIMATION_MOVE_OUT: 'animationMoveOut',
	ANIMATION_DISSOLVE: 'animationDissolve',
	FILTER_BOOKENDS: 'filterBookends',
	FILTER_COUNTDOWNS: 'filterCountdowns',
	FILTER_LOWERS: 'filterLowers',
	FILTER_SEGMENTS: 'filterSegments',
	FILTER_STYLEPACKS: 'filterStylepacks',
	FILTER_WALKUPS: 'filterWalkups',
	ARROW_BUTTON_LEFT: 'arrowButtonLeft',
	ARROW_BUTTON_RIGHT: 'arrowButtonRight',
	CUSTOM_THEME: 'customTheme',
	CROWN: 'crown',
} as const;